export const Policies = {
  types: {
    // Read
    HOME: 'Summary:Read',
    ACCOUNT: 'Account:Read',
    ACTIVITY: 'Activity:Read',
    HANDY_LINK: 'PaymentLink:Read',
    HANDY_QR: 'PaymentLink:Read',
    MOBILE_BALANCE: 'MobileRecharge:Read',
    ITAU: 'PaymentGateway:Read',
    LOANS: 'Loan:Read',
    YOUR_MONEY: 'Calendar:Read',
    HISTORY: 'WithdrawalHistory:Read',
    REVERSALS: 'Reversal:Read',
    VOUCHERS: 'Invoice:Read',
    PROFILE: 'Profile:Read',
    MANAGE_USERS: 'User:Read',
    BRANCHES: 'Branch:Read',
    OPERATION_DEATAILS: 'OperationDetail:Read',
    NOTIFICATIONS: 'Notification:Read',
    PROVIDER: 'Provider:Read',
    PROVIDER_CREATE_PAYMENT: 'Provider:CreatePayment',
    SUBSCRIBER: 'Subscriber:Read',
    PROVIDERS_SUBSCRIPTIONS_PLANS: 'SubscriptionPlan:Read',
    PROVIDERS_SUBSCRIPTIONS_SHARE_PLAN: 'ShareSubscriptionPlan:Read',
    PROVIDERS_SUBSCRIPTIONS_PROMOTIONS: 'Promotion:Read',
    PROVIDERS_SUBSCRIPTIONS_SUBSCRIPTIONS: 'Subscription:Read',
    PROVIDERS_SUBSCRIPTIONS_SUBSCRIPTIONS_MANAGE: 'ManageSubscription:Read',
    PROVIDERS_SUBSCRIPTIONS_TRANSACTIONS: 'Transaction:Read',
    // Write
    ACTIVITY_WRITE: 'Activity:Write',
    HANDY_LINK_WRITE: 'PaymentLink:Write',
    HANDY_QR_WRITE: 'PaymentLink:Write',
    ITAU_WRITE: 'PaymentGateway:Write',
    LOANS_WRITE: 'Loan:Write',
    MANAGE_USERS_WRITE: 'User:Write',
    NOTIFICATIONS_WRITE: 'Notification:Write',
    SENSITIVE_DATA: 'SensitiveData:Write',
    PROVIDER_WRITE: 'Provider:Write',
    SUBSCRIBER_WRITE: 'Subscriber:Write',
    PROFILE_WRITE: 'Profile:Write',
    PROVIDERS_SUBSCRIPTIONS_PLANS_WRITE: 'SubscriptionPlan:Write',
    PROVIDERS_SUBSCRIPTIONS_PROMOTIONS_WRITE: 'Promotion:Write',
    PROVIDERS_SUBSCRIPTIONS_SUBSCRIPTIONS_WRITE: 'Subscription:Write',
    PROVIDERS_SUBSCRIPTIONS_TRANSACTIONS_WRITE: 'Transaction:Write',
    REFUND_WRITE: 'Refund:Write',
    // Super
    SUPER_READ: 'Super:Read',
  },
};
